module.exports = __webpack_public_path__ + "static/media/RST_pull_annotations.b25f6d83.png";